import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Role } from 'dashboard/models/role';
import { User, UserStatus } from 'dashboard/models/user';
import { setRole, setUsers } from 'dashboard/redux/actions/role';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadRole(id: string) {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.getResource<Role>(ApiEndpoint.Role, id);

    dispatch(setRole(response.data));
  };
}

export const loadPaginatedRoleUserList =
  (
    roleId: string,
    pageNumber: number,
    pageSize: number,
    setPaginationMeta: (meta: PaginationParams) => void,
    filter: { omni?: string; statuses?: UserStatus[] } = {},
  ): DashboardThunkAction =>
  async (dispatch) => {
    const { data: users, meta } = await SessionClientDashboard.listResource<User, PaginationParams>(
      ApiEndpoint.User,
      {
        page: {
          number: pageNumber,
          size: pageSize,
        },
        filter: {
          ...filter,
          roleId,
        },
      },
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    setPaginationMeta(meta);
    dispatch(setUsers(users));
  };
